export const validateRut = (input) => {
    if (input.length < 8) return false;

    const text = input.replace(/[^kK0-9]/g, "");
    if (text.length === 0) return false;

    const rut = text.substring(0, text.length - 1);
    const drut = text.substring(text.length - 1);

    var mul = 2,
        sum = 0;

    for (var i = rut.length - 1; i >= 0; i--) {
        sum = sum + rut.charAt(i) * mul;
        if (mul === 7) mul = 2;
        else mul++;
    }

    const res = sum % 11;
    let dvr;
    switch (res) {
        case 1: {
            dvr = "k";
            break;
        }
        case 0: {
            dvr = "0";
            break;
        }
        default: {
            dvr = `${11 - res}`;
        }
    }

    return dvr === drut.toLowerCase();
};

export const validateDate = ({date, today}) => {
    try {
        if (date.trim() === "") {
            throw new Error();
        } else {
            const [day, month, year = ""] = date.split("/");
            const entryDate = new Date(`${year}-${month}-${day}T00:00:00`);

            if (year === "" || year.length < 4) {
                return "Respetar el formato DD/MM/AAAA";
            }
            const validdays = new Date(Number(year), Number(month), 0).getDate();
            if (
                date.trim() === "" ||
                entryDate.toDateString() === "Invalid Date" ||
                validdays < Number(day)
            ) {
                throw new Error();
            }
            const maxDate = new Date(
                `${today.getFullYear() - 18}-${month}-${day}T00:00:00`
            );
            const minDate = new Date(
                `${today.getFullYear() - 120}-${month}-${day}T00:00:00`
            );

            if (Number(year) < minDate.getFullYear()) {
                return "Fecha fuera de rango";
            }
            if (entryDate > today) {
                throw new Error();
            }
            if (entryDate >= maxDate) {
                return "Fecha no válida, debe tener por lo menos 18 años";
            }
        }

        return "";
    } catch (err) {
        return "Fecha no válida";
    }
};

export const isRequired = (value) => {
    return !(value === null || value === undefined || value.trim() === "");
};

export const isEmail = (value) => {
    if (dotsAndUnderscoreDuplicad(value)) {
        return false;
    }
    const expression = new RegExp(
        /^([a-zA-Z0-9_.]+)([[a-zA-Z0-9])+@([a-zA-Z0-9]+)+([a-zA-Z0-9-.]+)([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/
    );
    const valid = expression.test(value);

    return valid;
};

const dotsAndUnderscoreDuplicad = (value) => {
    return value.includes("..") || value.includes("__");
};
